import { books } from "../data/books.js";
import { Icon } from "../components/Icons.jsx";
import Seo from "../components/Seo.jsx";

export default function PublishedBooks() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Published Books",
    description: "Published books on the Bhagavad Gita, Ramayana, Sathya Yuga, and freedom from overthinking.",
    hasPart: books.map((book) => ({
      "@type": "Book",
      name: `${book.title}: ${book.subtitle}`,
      identifier: book.asin,
      url: book.amazonUrl,
    })),
  };

  return (
    <>
      <Seo
        title="Published Books · Simple Meditation World"
        description="Books on the Bhagavad Gita, Ramayana, Sathya Yuga, and freedom from overthinking."
        path="/published-books"
        schema={schema}
      />
      <section className="section-night books-hero" style={{ paddingTop: 80, paddingBottom: 70 }}>
        <div className="container books-hero-grid">
          <div>
            <span className="eyebrow" style={{ color: "var(--gold)" }}>Published books</span>
            <h1 className="books-title">
              Four contemplative works for the <em>inner path</em>
            </h1>
            <p className="books-intro">
              Companion readings for seekers drawn to the Gita, the Ramayana, the turning of the ages, and the practical freedom of a quieter mind.
            </p>
          </div>
          <div className="books-stack" aria-hidden="true">
            {books.map((book, index) => (
              <div key={book.asin} className={`mini-book mini-book-${index + 1}`}>
                <span>{book.theme}</span>
                <strong>{book.title}</strong>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-ivory books-section">
        <div className="container">
          <div className="books-grid">
            {books.map((book, index) => (
              <article key={book.asin} className="book-card">
                <div className={`book-cover book-cover-${index + 1}`} aria-hidden="true">
                  <div className="book-cover-kicker">{book.theme}</div>
                  <div className="book-cover-title">{book.title}</div>
                  <div className="book-cover-line" />
                </div>
                <div className="book-copy">
                  <div className="book-meta">Kindle edition · ASIN {book.asin}</div>
                  <h2>{book.title}</h2>
                  <h3>{book.subtitle}</h3>
                  <p>{book.brief}</p>
                  <div className="book-tone">{book.tone}</div>
                  <a className="btn btn-primary book-link" href={book.amazonUrl} target="_blank" rel="noreferrer">
                    View on Amazon {Icon.arrowSm()}
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
